import { isNullOrEmpty } from '@abp/ng.core';
import { Component, Injector, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AppComponentBase } from 'src/app/shared/app-component-base';
import { StepData } from 'src/app/shared/components/delivery-step-progress/delivery-step-progress.component';

@Component({
  selector: 'app-delivery-details',
  templateUrl: './delivery-details.component.html',
  styleUrls: ['./delivery-details.component.scss'],
})
export class DeliveryDetailsComponent extends AppComponentBase implements OnInit {
  // Thông tin sản phẩm
  productName: string;
  productImage: string;

  // Thông tin giao hàng
  expectedDeliveryDate: string;
  trackingNumber: string;

  // Trạng thái giao hàng
  currentStep: number = 2;

  // Thông tin fan message (tùy chọn)
  fanMessage: string;

  constructor(
    private dialogConfig: DynamicDialogConfig,
    private dialogRef: DynamicDialogRef,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
    // Xóa box-shadow của dialog
    let el = document.querySelector<HTMLElement>('.p-dialog');
    if (el) {
      el.style.boxShadow = 'unset';
    }

    // Lấy dữ liệu từ dialogConfig
    const data = this.dialogConfig.data || {};
    this.productName = data.productName || '';
    this.productImage = data.productImage || '';
    this.expectedDeliveryDate = data.expectedDeliveryDate || '';
    this.trackingNumber = data.trackingNumber || '';
    this.currentStep = data.currentStep !== undefined ? data.currentStep : 0;
    this.fanMessage = data.fanMessage || '';
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  submitConfirmation(): void {
    this.dialogRef.close({ confirmed: true, messageToFan: isNullOrEmpty(this.fanMessage.trim()) ? this.L('::DeliveryGift:MessageToFan:PlaceHolder') : this.fanMessage.trim() });
  }
}
